export function isTodoLearnMoreUrl(learnMoreUrl: string | null | undefined): boolean {
    return Boolean(learnMoreUrl && learnMoreUrl.trim().toLowerCase() === 'todo');
}

export function getPublishedLearnMoreUrl(
    learnMoreUrl: string | null | undefined
): string | undefined {
    if (!learnMoreUrl || isTodoLearnMoreUrl(learnMoreUrl)) {
        return undefined;
    }

    return learnMoreUrl;
}
